import countries from './countries';
import defaultFlag from '../../static/icons/question_mark.svg';

// Import all flag SVGs statically
const flagModules = import.meta.glob('../../static/flagsIcons/*.svg', { eager: true });

// Create a map of country codes to flag URLs
const flagsMap: Record<string, string> = {};
Object.entries(flagModules).forEach(([path, module]) => {
    const countryCode = path.split('/').pop()?.replace('.svg', '');
    if (countryCode && module) {
        flagsMap[countryCode] = (module as any).default || module;
    }
});

export function mapCodeIcon(code: string) {
    const country = countries.find((item) => item.code === code);
    if (country && flagsMap[code]) {
        return flagsMap[code];
    }
    return defaultFlag;
}
